export const onMutateError = (error, notify) => {
    if (error.body.error === 'overlapping_date') {
        notify('Data koliduje z innym zdarzeniem');
    } else {
        notify('Unknown error ocurred');
    }

    throw error;
}